<template>
    <div>
        <!--apollo graphql query-->
        <ApolloQuery :query="require('../graphql/pinned-repos.graphql')"
                     :variables="{ named, count }"
                     v-slot="{ result: { loading, error, data } }">

            <!--handling for the result of the query-->

            <!--show a spinner for when the data is loading-->
            <div v-if="loading"
                 class="loading">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>

            <!--show a cute gif when there's an error-->
            <div v-else-if="error"
                 class="error">

                <!--a card that has a hover effect-->
                <md-card md-with-hover>
                    <!--actual gif-->
                    <md-card-media-cover md-solid>
                        <md-card-media>
                            <img src="../assets/error.gif" alt="Something is clearly wrong!">
                        </md-card-media>
                    </md-card-media-cover>

                    <!--quote from the gif-->
                    <md-card-area>
                        <md-card-header>
                            <span class="md-subhead">Something is clearly wrong!</span>
                        </md-card-header>
                    </md-card-area>
                </md-card>

            </div>

            <!--actual cards with project information-->
            <!--suppress JSUnresolvedVariable -->
            <div v-else-if="data"
                 class="md-layout"
                 v-for="item in data.user.pinnedItems.nodes" :key="item.name">

                <!--a card that has a hover effect-->
                <md-card md-with-hover>

                    <!--show the name of the project with its primary language-->
                    <md-card-header>
                        <!--name of the project-->
                        <div class="md-title">
                            {{ item.name }}
                        </div>

                        <!--primary language of the project-->
                        <!--suppress JSUnresolvedVariable -->
                        <a :style="{ color: item.primaryLanguage.color }"
                           :href="links[item.primaryLanguage.name.toLowerCase()]" target="_blank">
                            {{ item.primaryLanguage.name }}
                        </a>
                        <div class="md-subhead">
                            <md-icon class="attribute" :md-src="icons.star"></md-icon>
                            <span class="md-caption">{{ item.stargazers.totalCount }}</span>

                            <span class="spacing"></span>

                            <md-icon class="attribute" :md-src="icons.fork"></md-icon>
                            <span class="md-caption">{{ item.forkCount }}</span>
                        </div>
                    </md-card-header>

                    <!--extra information about the project-->
                    <md-card-expand>

                        <md-card-actions md-alignment="space-between">
                            <!--link to the actual project-->
                            <md-button :href="item.url" target="_blank">
                                View Project
                            </md-button>

                            <!--button to expand description-->
                            <md-card-expand-trigger>
                                <md-button class="md-icon-button">
                                    <md-icon>keyboard_arrow_down</md-icon>
                                </md-button>
                            </md-card-expand-trigger>
                        </md-card-actions>

                        <!--short description of the project-->
                        <md-card-expand-content>
                            <md-card-content>
                                <div>
                                    {{ item.description }}
                                </div>
                            </md-card-content>
                        </md-card-expand-content>
                    </md-card-expand>
                </md-card>
            </div>
        </ApolloQuery>
    </div>
</template>

<script>
    export default {
        name: "Pins",
        props: {
            count: {
                type: Number,
                default: 3,
            },
            named: {
                type: String,
                default: "Sxtanna",
            }
        },
        data() {
            return {
                icons: {
                    fork: require('../assets/github_fork.svg'),
                    star: require('../assets/github_star.svg'),
                },
                links: {
                    "go": "https://golang.org/",
                    "java": "https://openjdk.java.net/",
                    "kotlin": "https://kotlinlang.org/",
                }
            };
        },
        methods: {
            log(data) {
                console.log(data);
            }
        }
    }
</script>

<style scoped>
    .md-layout {
        display: inline;
    }

    .md-subhead {
        padding-top: 10px;
    }

    .md-card {
        width: 320px;
        margin: 20px;
        display: inline-block;
        vertical-align: top;
    }

    .md-card-content {
        padding-top: 0;
    }

    .attribute {
        padding: 0 0;
        display: inline-block;
    }

    .spacing {
        padding: 0 10px;
    }
</style>